import { memo } from 'react';
import { useNavigate } from 'react-router';
import {
  BodyLight,
  Button,
  ButtonSizes,
  Heading1,
  ArticleSearch,
  openNotifyModal
} from '@/components/elements';
import { openSmsModal } from '@/components/elements/SmsModal';
import { FileExplorer } from '@/components/elements/FileExplorer/FileExplorer';

export function Images() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col w-4/5">
      <div className="flex justify-between h-16 mr-6 mt-3 align-middle">
        <Heading1 className="text-2xl text-black">Images</Heading1>
      </div>
      <div className="flex-grow bg-white p-10 mr-6 rounded">
        <FileExplorer/>
      </div>
    </div>
  );
};